/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S3_Apikey_BodyInputs */

const tr_mesafeli_s3_apikey_body = /** @type {(inputs: Mesafeli_S3_Apikey_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Müşteri'nin kendi pazaryeri hesabına ait kimlik bilgisi olup Platform tarafından AES-256-GCM şifrelemesi ile saklanır.`)
};

const en_mesafeli_s3_apikey_body = /** @type {(inputs: Mesafeli_S3_Apikey_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credentials belonging to the Customer's own marketplace account, stored by the Platform with AES-256-GCM encryption.`)
};

const de_mesafeli_s3_apikey_body = /** @type {(inputs: Mesafeli_S3_Apikey_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugangsdaten des Kunden zu seinem eigenen Marktplatzkonto, die von der Plattform mit AES-256-GCM-Verschlüsselung gespeichert werden.`)
};

const ru_mesafeli_s3_apikey_body = /** @type {(inputs: Mesafeli_S3_Apikey_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Учётные данные Клиента от его собственного аккаунта на маркетплейсе, которые хранятся Платформой с шифрованием AES-256-GCM.`)
};

/**
* | output |
* | --- |
* | "Credentials belonging to the Customer's own marketplace account, stored by the Platform with AES-256-GCM encryption." |
*
* @param {Mesafeli_S3_Apikey_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s3_apikey_body = /** @type {((inputs?: Mesafeli_S3_Apikey_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S3_Apikey_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s3_apikey_body(inputs)
	if (locale === "de") return de_mesafeli_s3_apikey_body(inputs)
	if (locale === "ru") return ru_mesafeli_s3_apikey_body(inputs)
	return tr_mesafeli_s3_apikey_body(inputs)
});